import controller from './document-viewer.controller'
import template from './document-viewer.html'

const documentViewerModule = angular.module('documentViewer', []).component('documentViewer', {
  restrict: 'E',
  template,
  controller,
  bindings: {
    documentApiUrl: '@',
    updatecount: '<',
  },
})

export default documentViewerModule


// WEBPACK FOOTER //
// ./client/common/document-viewer/document-viewer.js